import client from './client';
import { Obligation, PaginatedResponse } from '../types';

export const obligationsApi = {
  list: (params?: {
    page?: number;
    per_page?: number;
    status?: string;
    category?: string;
    priority?: string;
  }) => client.get<PaginatedResponse<Obligation>>('/obligations', { params }),

  get: (id: string) => client.get<Obligation>(`/obligations/${id}`),

  update: (id: string, data: Partial<Obligation>) =>
    client.put<Obligation>(`/obligations/${id}`, data),

  complete: (id: string) =>
    client.post(`/obligations/${id}/complete`),

  calendar: (month: number, year: number) =>
    client.get<Obligation[]>('/obligations/calendar', { params: { month, year } }),
};
